const isElementOffScreen = (el) => {
  if (!el) return false;

  const rect = el.getBoundingClientRect();
  const maxHeight = 400;

  const { innerHeight } = window;
  const diff = (rect.top + maxHeight - innerHeight) * -1;

  return { diff, top: rect.top };
};

const findParentElement = (el) => {
  if (el.tagName === "HTML" || el.tagName === "BODY") return undefined;
  if (el.parentElement.getAttribute("role") === "presentation")
    return el.parentElement;
  else return findParentElement(el.parentElement);
};

export const handleAccordionToggle = (e) => {
  if (!e) return;

  let popperRoot = findParentElement(e.target);
  if (!popperRoot) return;

  const menuElement = popperRoot.children[2];

  const { diff } = isElementOffScreen(menuElement);
  let translate = diff <= 0 ? diff : 0;
  menuElement?.style?.setProperty("transform", `translateY(${translate}px)`);
};
